<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Gestión de Roles</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" md="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="5"
            class="elevation-1"
            item-key="codigo"
            :loading="loading"
          >
            <template v-slot:item.acciones="{ item }">
              <v-icon
                v-if="vista.lectura"
                medium
                class="mr-2"
                @click.stop="editar(item, false)"
                >mdi-eye</v-icon
              >
              <v-icon
                v-if="vista.escritura && item.codigo != 'ADMINISTRADOR'"
                medium
                class="mr-2"
                @click.stop="editar(item, true)"
                >mdi-pencil</v-icon
              >
              <v-icon
                v-if="vista.supresion && item.codigo != 'ADMINISTRADOR'"
                medium
                class="mr-2"
                @click="eliminar(item)"
                >mdi-trash-can</v-icon
              >
            </template>
          </v-data-table>
          <br />
          <v-btn
            v-if="vista.escritura"
            fab
            dark
            large
            color="primary"
            fixed
            right
            bottom
            @click="nuevo"
          >
            <v-icon dark>add</v-icon>
          </v-btn>
          <v-dialog v-model="dialogo.open" persistent max-width="650px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ dialogo.titulo }}</span>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        :disabled="!dialogo.nuevo || dialogo.loading"
                        @input="
                          v => {
                            dialogo.codigo = v.toUpperCase();
                          }
                        "
                        @keyup.enter="guardar()"
                        dense
                        label="Nombre"
                        required
                        v-model="dialogo.codigo"
                        placeholder="Nombre"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="8">
                      <v-text-field
                        :disabled="!dialogo.edicion || dialogo.loading"
                        @keyup.enter="guardar()"
                        dense
                        label="Descripción"
                        v-model="dialogo.descripcion"
                        placeholder="Descripción"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">Módulo</th>
                              <th class="text-center">Consulta</th>
                              <th class="text-center">Modificación</th>
                              <th class="text-center">Eliminación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, idx) in dialogo.permisos"
                              :key="idx"
                            >
                              <td>{{ item.vista }}</td>
                              <td>
                                <v-layout justify-center>
                                  <v-checkbox
                                    class="ma-0"
                                    v-model="item.lectura"
                                    :disabled="
                                      !dialogo.edicion || dialogo.loading
                                    "
                                    hide-details
                                  ></v-checkbox>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout justify-center>
                                  <v-checkbox
                                    class="ma-0"
                                    v-model="item.escritura"
                                    :disabled="
                                      !dialogo.edicion || dialogo.loading
                                    "
                                    hide-details
                                  ></v-checkbox>
                                </v-layout>
                              </td>
                              <td>
                                <v-layout justify-center>
                                  <v-checkbox
                                    class="ma-0"
                                    v-model="item.supresion"
                                    :disabled="
                                      !dialogo.edicion || dialogo.loading
                                    "
                                    hide-details
                                  ></v-checkbox>
                                </v-layout>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col cols="3" sm="6" md="2" lg="2">
                      <label>Perfil:</label>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="4">
                      <v-checkbox
                        hide-details
                        dense
                        v-model="dialogo.cliente"
                        class="ma-0 pa-0"
                        label="Cliente"
                        :disabled="
                          !dialogo.edicion ||
                            dialogo.loading ||
                            !clienteHabilitado
                        "
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="4">
                      <v-checkbox
                        hide-details
                        dense
                        v-model="dialogo.postVenta"
                        class="ma-0 pa-0"
                        label="PostVenta"
                        :disabled="!dialogo.edicion || dialogo.loading"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click.stop="cerrar()"
                  :disabled="dialogo.loading"
                >
                  Cerrar
                </v-btn>
                <v-btn
                  v-if="dialogo.edicion"
                  color="blue darken-1"
                  text
                  @click.stop="guardar()"
                  :disabled="dialogo.loading"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dlgEliminar.open" persistent max-width="350px">
            <v-card>
              <v-card-title>
                <span class="headline">
                  ¿Eliminar rol?
                </span>
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click.stop="cerrarDlgEliminar(false)"
                  color="blue darken-1"
                  text
                >
                  No
                </v-btn>
                <v-btn
                  @click.stop="cerrarDlgEliminar(true)"
                  color="blue darken-1"
                  text
                >
                  Si
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Roles",
  data: () => ({
    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "correlativo"
      },
      { text: "Nombre", value: "codigo" },
      { text: "Descripción", value: "descripcion" },
      { text: "Acciones", value: "acciones", sortable: false }
    ],
    items: [],
    loading: false,
    dialogo: {
      cliente: false,
      postVenta: false,
      nuevo: false,
      edicion: false,
      loading: false,
      open: false,
      codigo: "",
      descripcion: "",
      permisos: []
    },
    dlgEliminar: {
      open: false,
      resolve: null,
      motivo: "",
      error: ""
    },
    vista: {}
  }),
  computed: {
    ...mapGetters(["getToken"]),
    clienteHabilitado() {
      const rol = this.items.find(x => x.cliente);
      return rol == undefined || rol.codigo == this.dialogo.codigo;
    }
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    abrirDlgEliminar() {
      return new Promise(resolve => {
        this.dlgEliminar.motivo = "";
        this.dlgEliminar.resolve = resolve;
        this.dlgEliminar.open = true;
      });
    },
    cerrarDlgEliminar(resultado) {
      this.dlgEliminar.open = false;
      this.dlgEliminar.resolve(resultado);
      this.dlgEliminar.error = "";
      this.dlgEliminar.resolve = null;
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=ADMINISTRACION.ROLES`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.vista = respuesta.data;
    },
    async listar() {
      if (this.loading) {
        return;
      }
      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/rol/listar",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      } finally {
        this.loading = false;
      }

      this.items = respuesta.data.map((el, idx) => {
        return {
          ...el,
          correlativo: idx + 1,
          acciones: null
        };
      });
    },
    nuevo() {
      this.dialogo.cliente = false;
      this.dialogo.postVenta = false;
      this.dialogo.nuevo = true;
      this.dialogo.edicion = true;
      this.dialogo.titulo = "Nuevo Rol";
      this.dialogo.codigo = "";
      this.dialogo.descripcion = "";
      this.dialogo.open = true;

      (async instancia => {
        let respuesta;
        try {
          respuesta = await axios.get(
            process.env.VUE_APP_BASE_PATH + "/api/rol/ListarVistas",
            {
              headers: { Authorization: `Bearer ${instancia.getToken}` }
            }
          );
        } catch (error) {
          if (error.response.status == 400) {
            instancia.showAlerta2({
              mensaje: error.response.data.error_description,
              tipo: 3
            });
          } else {
            instancia.salir();
          }
          return;
        }

        instancia.dialogo.permisos = respuesta.data.map(x => ({
          vista: x,
          lectura: false,
          escritura: false,
          supresion: false
        }));
      })(this);
    },
    editar(item, edicion) {
      this.dialogo.nuevo = false;
      this.dialogo.edicion = edicion;
      this.dialogo.titulo = (edicion ? "Edición" : "Consulta") + " de Rol";

      this.dialogo.open = true;

      (async instancia => {
        let respuesta;
        try {
          respuesta = await axios.get(
            process.env.VUE_APP_BASE_PATH +
              `/api/rol/obtener?codigo=${item.codigo}`,
            { headers: { Authorization: `Bearer ${instancia.getToken}` } }
          );
        } catch (error) {
          if (error.response.status == 400) {
            instancia.showAlerta2({
              mensaje: error.response.data.error_description,
              tipo: 3
            });
          } else {
            instancia.salir();
          }
          return;
        }

        instancia.dialogo.cliente = respuesta.data.cliente;
        instancia.dialogo.postVenta = respuesta.data.post_venta;
        instancia.dialogo.codigo = respuesta.data.codigo;
        instancia.dialogo.descripcion = respuesta.data.descripcion;
        instancia.dialogo.permisos = respuesta.data.permisos;
      })(this);
    },
    async guardar() {
      const params = {
        nuevo: this.dialogo.nuevo,
        codigo: this.dialogo.codigo,
        cliente: this.dialogo.cliente,
        post_venta: this.dialogo.postVenta,
        descripcion: this.dialogo.descripcion,
        permisos: JSON.parse(JSON.stringify(this.dialogo.permisos))
      };

      let respuesta;
      try {
        this.dialogo.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/rol/Guardar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.dialogo.loading = false;
      }

      this.listar();

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });

      if (respuesta.data.tipo == 0) {
        this.dialogo.open = false;
      }
    },
    async eliminar(item) {
      if (!(await this.abrirDlgEliminar())) {
        return;
      }
      const params = {
        codigo: item.codigo
      };

      let respuesta;
      try {
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/rol/eliminar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }
      this.listar();
      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });
    },
    cerrar() {
      this.dialogo.open = false;
      this.dialogo.codigo = "";
      this.dialogo.descripcion = "";
      this.dialogo.permisos = [];
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  async created() {
    await this.loadVista();
    this.listar();
  }
};
</script>

<style scoped></style>
